import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Box, Typography } from '@mui/material'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const StackedBarChart = ({ data, totalAssociateCount }) => {
  const chartData = {
    labels: data.map((item) => item.month),
    datasets: [
      {
        label: 'Active',
        data: data.map((item) => (item.active > 0 ? item.active : null)),
        backgroundColor: '#F6764E',
        borderRadius: {
          topLeft: 0,
          topRight: 0,
          bottomLeft: 0,
          bottomRight: 0,
        },
        barPercentage: 0.3,
      },
      {
        label: 'Inactive',
        data: data.map((item) => (item.inActive > 0 ? item.inActive : null)),
        backgroundColor: 'rgba(255, 168, 141, 0.5)',
        borderRadius: {
          topLeft: 5,
          topRight: 5,
          bottomLeft: 0,
          bottomRight: 0,
        },
        barPercentage: 0.3,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        ticks: {
          callback: function (value, index) {
            return index + 1
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: { display: false },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) =>
            `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
      },
      datalabels: {
        display: false,
      },
    },
  }

  return (
    <Box width='100%' height='100%' sx={{ marginBottom: '300px' }}>
      <Typography
        variant='h4'
        sx={{
          fontFamily: 'Work Sans',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
          color: '#F6764E',
          marginLeft: '20px',
          marginTop: '8px',
        }}>
        Associates By Month
      </Typography>
      <Typography
        variant='h4'
        sx={{
          fontFamily: 'Work Sans',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          color: '#F6764E',
          marginLeft: '20px',
          marginBottom: '1px',
          marginTop: '8px',
        }}>
        {totalAssociateCount}
      </Typography>
      <Box width='100%' height='65%'>
        <Bar data={chartData} options={options} />
      </Box>
    </Box>
  )
}

export default StackedBarChart
